import Colaborador from '../types/negocio/Colaborador';
import api from './api';
import BaseService from './BaseService';

class ColaboradorService extends BaseService<Colaborador> {
 
  constructor() {
    super('colaborador', api);
  }

  /**
   * Lista todos os colaboradores ativos
   * @returns Promise com a lista de colaboradores ativos
   */
  async listarAtivos(): Promise<Colaborador[]> {
    const response = await this.api.get(`/api/${this.route}/ativos`);
    return response.data;
  }

  /**
   * Busca um colaborador pelo email
   * @param email Email do colaborador
   * @returns Promise com o colaborador encontrado
   */
  async buscarPorEmail(email: string): Promise<Colaborador | null> {
    try {
      const response = await this.api.get(`/api/${this.route}/email/${email}`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
  
}

export const colaboradorService = new ColaboradorService();